'use strict';

Object.defineProperty(exports, '__esModule', {
	value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _loginHtml = require('./login.html');

var _loginHtml2 = _interopRequireDefault(_loginHtml);

var _loginController = require('./login.controller');

var _loginController2 = _interopRequireDefault(_loginController);

/**
 * @ngdoc function
 * @name TwitterBackup:controller:HomePageCtrl
 * @description
 */

function routeConfig($stateProvider) {
	'ngInject';

	$stateProvider
	// Using a '.' within a state name declares a child within a parent.
	// So you have a new state 'homepage' within the parent 'app' state.
	.state('app.public.login', {
		url: '/admin',
		template: _loginHtml2['default'],
		controller: _loginController2['default'],
		controllerAs: 'vm'
	});
}

exports['default'] = routeConfig;
module.exports = exports['default'];


/** WEBPACK FOOTER **
 ** ./client/public/login_screen/login.route.js
 **/